import React, { useState, Component } from 'react';
import { MapPin, Phone, Clock, Mail } from 'lucide-react';
import { useTranslations } from '../hooks/useTranslations';
export function Contact() {
  const {
    t
  } = useTranslations();
  const [formState, setFormState] = useState<'idle' | 'submitting' | 'success'>('idle');
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    company: '',
    service: '',
    message: ''
  });
  const [consents, setConsents] = useState({
    termsAgreed: false,
    smsConsent: false
  });
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.id]: e.target.value
    });
  };
  const handleConsentChange = (field: 'termsAgreed' | 'smsConsent') => {
    setConsents({
      ...consents,
      [field]: !consents[field]
    });
  };
  const isFormValid = consents.termsAgreed;
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!isFormValid) return;
    setFormState('submitting');
    setTimeout(() => {
      setFormState('success');
      const message = `Hola quiero información sobre financiamiento para mi negocio

Nombre: ${formData.firstName} ${formData.lastName}
Email: ${formData.email}
Teléfono: ${formData.phone}
Empresa: ${formData.company}
Interesado en: ${formData.service}
Mensaje: ${formData.message || 'N/A'}
SMS Consent: ${consents.smsConsent ? 'Yes' : 'No'}`;
      const encodedMessage = encodeURIComponent(message);
      setTimeout(() => {
        window.location.href = `https://wa.me/17862726132?text=${encodedMessage}`;
      }, 1500);
    }, 1000);
  };
  return <section id="contact" className="py-10 bg-gradient-to-br from-white to-[#f0faf4]" data-id="element-49">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-50">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-51">
          {/* Left Side - Form (moved to top/left) */}
          <div className="bg-white rounded-2xl p-8 shadow-xl border border-gray-100 order-1 lg:order-1" data-id="element-52">
            <h3 className="text-xl font-medium text-gray-900 mb-8" data-id="element-53">
              {t('contact.formTitle')}
            </h3>

            {formState === 'success' ? <div className="text-center py-12" data-id="element-54">
                <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-55">
                  <span className="text-green-600 text-2xl" data-id="element-56">✓</span>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-57">
                  {t('contact.successTitle')}
                </h3>
                <p className="text-gray-600" data-id="element-58">{t('contact.successMessage')}</p>
              </div> : <form onSubmit={handleSubmit} className="space-y-5" data-id="element-59">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-5" data-id="element-60">
                  <div data-id="element-61">
                    <label htmlFor="firstName" className="block text-xs text-gray-700 mb-1" data-id="element-62">
                      {t('contact.firstName')}{' '}
                      <span className="text-red-500" data-id="element-63">*</span>
                    </label>
                    <input type="text" id="firstName" required value={formData.firstName} onChange={handleInputChange} placeholder="John" className="w-full px-4 py-2.5 bg-gray-50 border border-transparent rounded-lg text-sm focus:bg-white focus:border-[#00E676] focus:ring-1 focus:ring-[#00E676] outline-none transition-all" data-id="element-64" />
                  </div>
                  <div data-id="element-65">
                    <label htmlFor="lastName" className="block text-xs text-gray-700 mb-1" data-id="element-66">
                      {t('contact.lastName')}{' '}
                      <span className="text-red-500" data-id="element-67">*</span>
                    </label>
                    <input type="text" id="lastName" required value={formData.lastName} onChange={handleInputChange} placeholder="Doe" className="w-full px-4 py-2.5 bg-gray-50 border border-transparent rounded-lg text-sm focus:bg-white focus:border-[#00E676] focus:ring-1 focus:ring-[#00E676] outline-none transition-all" data-id="element-68" />
                  </div>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-5" data-id="element-69">
                  <div data-id="element-70">
                    <label htmlFor="email" className="block text-xs text-gray-700 mb-1" data-id="element-71">
                      {t('contact.emailLabel')}{' '}
                      <span className="text-red-500" data-id="element-72">*</span>
                    </label>
                    <input type="email" id="email" required value={formData.email} onChange={handleInputChange} placeholder="john@company.com" className="w-full px-4 py-2.5 bg-gray-50 border border-transparent rounded-lg text-sm focus:bg-white focus:border-[#00E676] focus:ring-1 focus:ring-[#00E676] outline-none transition-all" data-id="element-73" />
                  </div>
                  <div data-id="element-74">
                    <label htmlFor="phone" className="block text-xs text-gray-700 mb-1" data-id="element-75">
                      {t('contact.phoneLabel')}{' '}
                      <span className="text-red-500" data-id="element-76">*</span>
                    </label>
                    <input type="tel" id="phone" required value={formData.phone} onChange={handleInputChange} placeholder="(555) 123-4567" className="w-full px-4 py-2.5 bg-gray-50 border border-transparent rounded-lg text-sm focus:bg-white focus:border-[#00E676] focus:ring-1 focus:ring-[#00E676] outline-none transition-all" data-id="element-77" />
                  </div>
                </div>
                <div data-id="element-78">
                  <label htmlFor="company" className="block text-xs text-gray-700 mb-1" data-id="element-79">
                    {t('contact.company')}{' '}
                    <span className="text-red-500" data-id="element-80">*</span>
                  </label>
                  <input type="text" id="company" required value={formData.company} onChange={handleInputChange} placeholder="Your Business LLC" className="w-full px-4 py-2.5 bg-gray-50 border border-transparent rounded-lg text-sm focus:bg-white focus:border-[#00E676] focus:ring-1 focus:ring-[#00E676] outline-none transition-all" data-id="element-81" />
                </div>
                <div data-id="element-82">
                  <label htmlFor="service" className="block text-xs text-gray-700 mb-1" data-id="element-83">
                    {t('contact.interested')}{' '}
                    <span className="text-red-500" data-id="element-84">*</span>
                  </label>
                  <select id="service" required value={formData.service} onChange={handleInputChange} className="w-full px-4 py-2.5 bg-gray-50 border border-transparent rounded-lg text-sm focus:bg-white focus:border-[#00E676] focus:ring-1 focus:ring-[#00E676] outline-none transition-all appearance-none" data-id="element-85">
                    <option value="" data-id="element-86">
                      Selecciona una opción de financiamiento...
                    </option>
                    <option value="Préstamos Basado en Ingresos" data-id="element-87">
                      Préstamos Basado en Ingresos
                    </option>
                    <option value="Tarjetas de Crédito de Negocio" data-id="element-88">
                      Tarjetas de Crédito de Negocio
                    </option>
                    <option value="Líneas de Crédito Comerciales" data-id="element-89">
                      Líneas de Crédito Comerciales
                    </option>
                    <option value="Financiamiento de Equipos" data-id="element-90">
                      Financiamiento de Equipos
                    </option>
                    <option value="Programas SBA para Residentes" data-id="element-91">
                      Programas SBA para Residentes
                    </option>
                  </select>
                </div>
                <div data-id="element-92">
                  <label htmlFor="message" className="block text-xs text-gray-700 mb-1" data-id="element-93">
                    {t('contact.message')}
                  </label>
                  <textarea id="message" rows={3} value={formData.message} onChange={handleInputChange} placeholder={t('contact.messagePlaceholder')} className="w-full px-4 py-2.5 bg-gray-50 border border-transparent rounded-lg text-sm focus:bg-white focus:border-[#00E676] focus:ring-1 focus:ring-[#00E676] outline-none transition-all resize-none" data-id="element-94"></textarea>
                </div>
                <div className="space-y-4 pt-2" data-id="element-95">
                  <h4 className="text-sm font-bold text-gray-900" data-id="element-96">
                    Terms & SMS Consent
                  </h4>
                  <label className="flex items-start gap-2 cursor-pointer" data-id="element-97">
                    <input type="checkbox" checked={consents.termsAgreed} onChange={() => handleConsentChange('termsAgreed')} className="mt-1 w-4 h-4 rounded border-gray-300 text-[#00E676] focus:ring-[#00E676]" data-id="element-98" />
                    <span className="text-xs text-gray-600" data-id="element-99">
                      I agree to the{' '}
                      <a href="#/terms" className="text-[#00E676] hover:underline" data-id="element-100">
                        Terms and Condition
                      </a>{' '}
                      and{' '}
                      <a href="#/privacy" className="text-[#00E676] hover:underline" data-id="element-101">
                        Privacy Policy
                      </a>
                    </span>
                  </label>
                  <div className="bg-gray-50 p-3 rounded-lg border border-gray-100" data-id="element-102">
                    <p className="text-[10px] text-gray-500 leading-relaxed" data-id="element-103">
                      BRIXEN FUNDING LLC would like your consent to send text
                      message communications from +1 (800) 326-0670 to your
                      mobile number listed above, regarding customer care.
                      Consent is not a condition of purchase. Message frequency
                      varies. Message and data rates may apply. Reply STOP to
                      unsubscribe at any time. Reply HELP for assistance or more
                      information.
                    </p>
                  </div>
                  <label className="flex items-start gap-2 cursor-pointer" data-id="element-104">
                    <input type="checkbox" checked={consents.smsConsent} onChange={() => handleConsentChange('smsConsent')} className="mt-1 w-4 h-4 rounded border-gray-300 text-[#00E676] focus:ring-[#00E676]" data-id="element-105" />
                    <span className="text-xs text-gray-600" data-id="element-106">
                      Yes, I consent to receive informational messages from
                      BRIXEN FUNDING LLC regarding customer care.
                    </span>
                  </label>
                  <div className="bg-[#e6fcf0] p-3 rounded-lg border border-[#b3f5d1]" data-id="element-107">
                    <p className="text-[10px] text-gray-600" data-id="element-108">
                      We do not share your mobile opt-in information with
                      anyone. See our{' '}
                      <a href="#/privacy" className="text-[#00E676] hover:underline" data-id="element-109">
                        Privacy Policy
                      </a>{' '}
                      for more information on how we handle your data.
                    </p>
                  </div>
                  <div className="flex items-center justify-between border border-gray-200 rounded p-3 bg-gray-50 w-64" data-id="element-110">
                    <div className="flex items-center gap-2" data-id="element-111">
                      <input type="checkbox" className="w-5 h-5 rounded-sm border-gray-300" data-id="element-112" />
                      <span className="text-xs text-gray-700" data-id="element-113">
                        I'm not a robot
                      </span>
                    </div>
                    <div className="flex flex-col items-center" data-id="element-114">
                      <img src="https://www.gstatic.com/recaptcha/api2/logo_48.png" alt="reCAPTCHA" className="w-6 h-6 opacity-80" data-id="element-115" />
                      <span className="text-[8px] text-gray-500 mt-1" data-id="element-116">
                        reCAPTCHA
                      </span>
                    </div>
                  </div>
                </div>
                <button type="submit" disabled={!isFormValid || formState === 'submitting'} className="w-full py-3 px-6 bg-[#00E676] hover:bg-[#00d169] text-white text-sm font-bold rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed mt-4" data-id="element-117">
                  {formState === 'submitting' ? 'Procesando...' : 'Solicitar Llamada'}
                </button>
              </form>}
          </div>

          {/* Right Side - Info */}
          <div className="text-center lg:text-center order-2 lg:order-2" data-id="element-118">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8" data-id="element-119">
              Empresa
            </h2>

            <div className="grid grid-cols-2 gap-6" data-id="element-120">
              {/* Address */}
              <div className="flex flex-col items-center gap-2" data-id="element-121">
                <div className="w-11 h-11 rounded-lg bg-red-100 flex items-center justify-center" data-id="element-122">
                  <MapPin className="w-5 h-5 text-red-500" data-id="element-123" />
                </div>
                <h4 className="text-xs font-bold text-gray-900" data-id="element-124">Dirección</h4>
                <p className="text-[11px] text-gray-500 text-center leading-relaxed" data-id="element-125">
                  390 NE 191st St
                  <br data-id="element-126" />
                  Miami, FL 33179
                </p>
              </div>

              {/* Phone */}
              <div className="flex flex-col items-center gap-2" data-id="element-127">
                <div className="w-11 h-11 rounded-lg bg-blue-100 flex items-center justify-center" data-id="element-128">
                  <Phone className="w-5 h-5 text-blue-500" data-id="element-129" />
                </div>
                <h4 className="text-xs font-bold text-gray-900" data-id="element-130">Contáctanos</h4>
                <p className="text-[11px] text-gray-500 text-center leading-relaxed" data-id="element-131">
                  (786) 272-6132
                  <br data-id="element-132" />
                  Llamadas · WhatsApp
                </p>
              </div>

              {/* Hours */}
              <div className="flex flex-col items-center gap-2" data-id="element-133">
                <div className="w-11 h-11 rounded-lg bg-amber-100 flex items-center justify-center" data-id="element-134">
                  <Clock className="w-5 h-5 text-amber-500" data-id="element-135" />
                </div>
                <h4 className="text-xs font-bold text-gray-900" data-id="element-136">Horarios</h4>
                <p className="text-[11px] text-gray-500 text-center leading-relaxed" data-id="element-137">
                  Lun a Sáb: 9am a 9pm
                  <br data-id="element-138" />
                  Dom: Cerrado
                </p>
              </div>

              {/* Email */}
              <div className="flex flex-col items-center gap-2" data-id="element-139">
                <div className="w-11 h-11 rounded-lg bg-purple-100 flex items-center justify-center" data-id="element-140">
                  <Mail className="w-5 h-5 text-purple-500" data-id="element-141" />
                </div>
                <h4 className="text-xs font-bold text-gray-900" data-id="element-142">Soporte</h4>
                <p className="text-[11px] text-gray-500 text-center" data-id="element-143">
                  info@brixenfunding.com
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}